import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_OVERVIEW: MijnRoute = {
    path: 'beleggen',
    navigationEvent: 'toBeleggen',
    regex: /^\/beleggen$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent'
};
